import React, {useState, useEffect, useCallback} from "react";
import ErrorModal from "./ErrorModal";
import SubmissionListContent, {ItemPricing} from "./SubmissionListContent";
import I18n from 'i18n.js.erb'
import {
  parseSubmissionListState,
  CURRENCY_EURO,
  parseAmount,
  submissionListColorState,
  isDefined,
  titleize,
  isPresent,
  parseFeedbackName,
  SUBMISSION_LISTS_EVALUATIONS,
  VERY_HIGH_DEBOUNCE_TIME,
  getEvaluationByFeedback,
  insuranceRequested,
  isInAClosingState,
  HIGH_DEBOUNCE_TIME,
  parseHoursRange,
  SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES,
  renderHomePickupRequestedServiceDetails,
  renderReturnShipmentRequestedServiceDetails
} from "../../utils/utils";
import ShowLargeImageModal from "./ShowLargeImageModal";
import PDFGenerator from "./PDFGenerator";
import SuccessFlashMessage from "./SuccessFlashMessage";
import Address from "./Address";
import {debounce} from "lodash";
import SubmissionListAddressFormContainerModal from "./SubmissionListAddressFormContainerModal";
import SubmissionListTracking from "./SubmissionListTracking";
import SubmissionListWithdrawalCard from "./SubmissionListWithdrawalCard";
import SubmissionListCancellationNotice from "./SubmissionListCancellationNotice";
import IconTooltip from "./IconTooltip";
import SubmissionListAmounts from "./SubmissionListAmounts";




const SubmissionListSingleDetailSummary = ({
  iconPath,
  label,
  content,
  iconCssAdditionalClass,
  customHtml,
  labelCssClass,
  textTruncate,
  labelTooltip
}) => {

  return <div className="slx-summary__item">
    <img src={window.location.origin + iconPath} alt="" className={iconCssAdditionalClass ? iconCssAdditionalClass : ''} />
    <div className={`slx-summary__item-content ${textTruncate ? 'text-truncate' : ''}`}>
      <div className="slx-summary__label-row">
        <p className={`slx-label ${textTruncate ? 'text-truncate' : ''} ${labelCssClass ? labelCssClass : ''}`}>
          {label}
        </p>
        {
          labelTooltip &&
          <IconTooltip
            tooltipContentComponent={labelTooltip}
            customComponentToRender={<img src={window.location.origin + "/images/icons/summary_info.svg"} alt="" />}
            customComponentToRenderCssClass="slx-summary__label-icon"
          />
        }
      </div>
      {
        customHtml ?
          <div dangerouslySetInnerHTML={{ __html: customHtml }}></div>
        :
          <p className={`slx-value ${textTruncate ? 'text-truncate' : 'text-on-new-line'}`}>
            { content }
          </p>
      }
    </div>
  </div>
}


export const UserGeneralitiesSummary = ({
  submissionList,
  isMiddleman,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/user.svg"}
    label={isMiddleman || !submissionList.middleman ? I18n.t('js.indexSubmissionListsPage.tableHeaderUserOwnerGenerality').toUpperCase() : submissionList.company_point.toUpperCase()}
    content={isMiddleman || !submissionList.middleman ? submissionList.user_owner : submissionList.middleman.business_name}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const UserEmailSummary = ({
  submissionList,
  isMiddleman,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/email.svg"}
    label={(isMiddleman || !submissionList.middleman ? I18n.t('js.indexSubmissionListsPage.tableHeaderUserOwnerEmail') : submissionList.company_point + ' ' + I18n.t('js.indexSubmissionListsPage.tableHeaderUserEmail')).toUpperCase()}
    content={isMiddleman || !submissionList.middleman ? submissionList.owner_email : submissionList.middleman?.email}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const ConfirmationDateSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/calendar.svg"}
    label={I18n.t("js.indexSubmissionListsPage.tableHeaderConfirmedAt").toUpperCase()}
    content={submissionList.confirmed_at}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const ItemsCountSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/balls.svg"}
    label={I18n.t("js.indexSubmissionListsPage.tableHeaderItemsCount").toUpperCase()}
    content={submissionList.items_count}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


export const DiscountSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/discount.svg"}
    label={I18n.t("js.PDFGenerator.submissionLists.discount_code").toUpperCase()}
    content={isDefined(submissionList.voucher?.code) ? submissionList.voucher.code : (isDefined(submissionList.backoffice_voucher?.code) ? submissionList.backoffice_voucher.code : I18n.t("js.common.none"))}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


// service_type null = scope misto, nessun dettaglio del servizio da mostrare
export const OrderTypeSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  const serviceType = submissionList.service_type
  const serviceTypeKey = `js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}`

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/order_type.svg"}
    label={I18n.t("js.indexSubmissionListsPage.orderType.label").toUpperCase()}
    content={isDefined(serviceType) ? I18n.t(`${serviceTypeKey}.titleCompact`) : I18n.t("js.indexSubmissionListsPage.orderType.mixed")}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
    labelTooltip={
      isDefined(serviceType) &&
      <React.Fragment>
        <p className="text-weight-700">{I18n.t(`${serviceTypeKey}.title`).toUpperCase()}</p>
        {
          [1, 2, 3].map((index) => (
            <p key={index} className="text-left">{I18n.t(`${serviceTypeKey}.bullet${index}`)}</p>
          ))
        }
      </React.Fragment>
    }
  />
}


export const InsuranceServiceSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/shield.svg"}
    label={I18n.t("js.indexSubmissionListsPage.insurance").toUpperCase()}
    labelTooltip={<p className="text-left">{I18n.t("js.indexSubmissionListsPage.requestedServices.insurance")}</p>}
    content={ I18n.t(`js.common.choice_${insuranceRequested(submissionList) ? 'yes' : 'no'}`) + (insuranceRequested(submissionList) && submissionList.insured_value ? ' - ' + I18n.t("js.indexSubmissionListsPage.insuranceUpperLimit") + ' ' + parseAmount(submissionList.insured_value, 2) + CURRENCY_EURO : '')}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}


// I servizi di ritiro e consegna sono riepilogati in un unico campo SPEDIZIONE
const shippingServiceKey = (submissionList) => {
  const homePickUp = submissionList.home_pick_up_requested
  const returnDelivery = submissionList.return_delivery_requested
  if (homePickUp && returnDelivery) return 'both'
  if (homePickUp) return 'onlyPickUp'
  if (returnDelivery) return 'onlyDelivery'
  return 'none'
}


export const ShippingServiceSummary = ({
  submissionList,
  labelCssClass,
  textTruncate
}) => {

  return <SubmissionListSingleDetailSummary
    iconPath={"/images/icons/gray/shipping.svg"}
    label={I18n.t("js.indexSubmissionListsPage.shipping.label").toUpperCase()}
    content={I18n.t(`js.indexSubmissionListsPage.shipping.${shippingServiceKey(submissionList)}`)}
    labelCssClass={labelCssClass}
    textTruncate={textTruncate}
  />
}




const ShowPageSubmissionList = ({
    originalSubmissionList,
    countries,
    canEditSubmissionList
  }) => {

  const original_submission_list = JSON.parse(originalSubmissionList);
  const isMiddleman = original_submission_list?.is_middleman;
  const [ initCompleted, setInitCompleted ] = useState(false);
  const [ homePickUpAddress, setHomePickUpAddress ] = useState(original_submission_list.home_pick_up_address);
  const [ shipmentAddress, setShipmentAddress ] = useState(original_submission_list.shipment_address);
  const [ userAddresses, setUserAddresses ] = useState(original_submission_list.addresses ? original_submission_list.addresses : []);
  const [ evaluations, setEvaluations ] = useState(original_submission_list.evaluations);
  const [ feedbacks, setFeedbacks ] = useState(original_submission_list.grader_company?.feedbacks);
  const [ review, setReview ] = useState(original_submission_list.review);
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false);
  const [ showErrorModal, setShowErrorModal ] = useState(false);
  const [ showZoomImg, setShowZoomImg ] = useState(false);
  const [ blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage ] = useState(null);
  const [ middlemanNote, setMiddlemanNote ] = useState(original_submission_list.middleman_note);
  const [ editMiddlemanNote, setEditMiddlemanNote ] = useState(false);

  // console.log('original_submission_list: ', original_submission_list);

  useEffect(() => {
    if (!initCompleted)
      setInitCompleted(true);
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateReview();
      return debouncedUpdateReview.cancel;
    }
  }, [review, debouncedUpdateReview]);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateMiddlemanNote();
      return debouncedUpdateMiddlemanNote.cancel;
    }
  }, [middlemanNote, debouncedUpdateMiddlemanNote]);


  // Funzione che esegue l'update debouncato della recensione data dall'utente alla submission list
  const debouncedUpdateReview = useCallback(
    debounce(() => {
      if (isPresent(review)) {
        updateReview()
      }
    }, VERY_HIGH_DEBOUNCE_TIME),
    [review]
  );


  // Funzione che esegue l'update debouncato delle note immesse dall'aggregatore per la submission list
  const debouncedUpdateMiddlemanNote = useCallback(
    debounce(() => {
      if (isPresent(middlemanNote)) {
        updateMiddlemanNote()
      }
    }, HIGH_DEBOUNCE_TIME),
    [middlemanNote]
  );


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, blueprintImage) => {
    e.stopPropagation();
    if (blueprintImage && blueprintImage.xx_large_image_url) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }


  // Funzione che verifica se la submission list corrente possa essere valutata e recensita dall'utente
  // sull'interfaccia grafica
  const cabBeEvaluated = () => {
    return original_submission_list.can_be_evaluated_by_current_user && !original_submission_list.evaluation_time_limit_expired
  }


  // Funzione che aggiorna la valutazione dell'utente in corrispondenza di un determinato feedback della submission list
  const updateEvaluation = (feedbackId, value) => {
    if (cabBeEvaluated()) {
      let url = `/submission_lists/${original_submission_list.id}`;

      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({evaluation: { feedback_id: feedbackId, value: value }}),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json()
        })
        .then((data) => {
          const newEvaluations = (isDefined(evaluations) ? {...evaluations} : {})
          newEvaluations[feedbackId] = value;
          setEvaluations(newEvaluations);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che aggiorna la recensione data dall'utente alla submission list
  const updateReview = () => {
    if (cabBeEvaluated()) {
      let url = `/submission_lists/${original_submission_list.id}`;

      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({review: review}),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json()
        })
        .then((data) => { })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che aggiorna le note immesse dall'aggregatore per la submission list
  const updateMiddlemanNote = () => {
    let url = `/submission_lists/${original_submission_list.id}`;

    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({middleman_note: middlemanNote}),
    })
      .then((res) => {
        if (!res.ok)
          throw Error("An error occour during saving data on the database");
        else
          return res.json()
      })
      .then((data) => { })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }



  // Funzione che ritorna tutti gli indirizzi dell'utente
  const availableUserAddresses = (userAddress) => {
    const addresses = userAddresses.filter(address => address.country_id === userAddress.country_id);
    if (addresses.filter(a => a.id === userAddress.id).length === 0)
      return [ ...addresses, { ...userAddress }];
    return addresses;
  }


  // Ritiro a domicilio effettivamente richiesto dal cliente: mostra la relativa card indirizzo
  const homePickUpRequestedDetails = renderHomePickupRequestedServiceDetails(original_submission_list);
  // Consegna di ritorno richiesta: mostra la relativa card indirizzo
  const returnShipmentRequestedDetails = renderReturnShipmentRequestedServiceDetails(original_submission_list);
  // Ritiro a domicilio non richiesto: il cliente deve spedire da sé, mostra il pulsante di download delle istruzioni al posto dell'indirizzo
  const showSelfShipCard = !homePickUpRequestedDetails &&
    !original_submission_list.hide_shipment_and_invoicing_info_to_user &&
    SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES.includes(original_submission_list.state);
  // Ritiro richiesto: le istruzioni restano scaricabili dalla card indirizzo finche' l'ordine non e' ricevuto
  const showHomePickUpInstructions = homePickUpRequestedDetails &&
    SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES.includes(original_submission_list.state);
  // Le istruzioni di spedizione vivono nella card "Invio ordine" del riepilogo e i riepiloghi PDF
  // stanno nei blocchi importi: qui resta solo la fattura, e la riga sparisce se non c'e'
  const showDownloadButtons = isPresent(original_submission_list.invoice_link);
  // Prefisso dei campi importo da mostrare: il cliente di un middleman vede gli importi a lui riservati
  const amountPrefix = isPresent(original_submission_list.middleman) && !isMiddleman ? 'customer_' : '';
  // L'aggregatore che guarda un proprio ordine vede due blocchi di importi: i suoi e quelli del suo cliente
  const isMiddlemanOrder = isPresent(original_submission_list.middleman) && isMiddleman;




  return (
    <React.Fragment>
      {
        initCompleted &&
          <React.Fragment>
            {/*  HEADER DELLA PAGINA */}
            <div className="row d-block justify-content-center text-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px px-3">
              <div>
                <h2><b>{I18n.t('js.filters.order')} {original_submission_list.number}</b></h2>
              </div>
              {
                original_submission_list.title &&
                  <div>
                    <h3><b>{original_submission_list.title}</b></h3>
                  </div>
              }
            </div>




            {/*  SEZIONE DATI DI RIEPILOGO DELLA SUBMISSION LIST */}
            <div id="submission_list_summary_details">
              <div className="slx-summary">
                {
                  (isMiddleman || original_submission_list.middleman) &&
                    <React.Fragment>
                      <div className="slx-summary__cell slx-summary__cell--half">
                        <UserGeneralitiesSummary
                          submissionList={original_submission_list}
                          isMiddleman={isMiddleman}
                        />
                      </div>

                      <div className="slx-summary__cell slx-summary__cell--half">
                        <UserEmailSummary
                          submissionList={original_submission_list}
                          isMiddleman={isMiddleman}
                        />
                      </div>
                    </React.Fragment>
                }

                <div className="slx-summary__cell">
                  <OrderTypeSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="slx-summary__cell">
                  <div className="slx-summary__item">
                    <img src={window.location.origin + `/images/icons/gray/money.svg`} alt="amount" />
                    <div className="slx-summary__item-content">
                      <p className="slx-label">
                        {I18n.t("js.editSubmissionListPage.amount").toUpperCase()}
                      </p>
                      <div className="d-flex align-items-center">
                        <ItemPricing
                          item={original_submission_list}
                          amountToRender={isMiddleman ? 'amount' : 'customer_amount'}
                        />
                        <img src={window.location.origin + `/images/icons/circle-arrow-down.svg`}
                             className="ml-2 cursor-pointer" width="16" height="16" alt="pricing_summary_link"
                             onClick={() => document.querySelector('#pricing_summary_section').scrollIntoView(false)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="slx-summary__cell">
                  <ConfirmationDateSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="slx-summary__cell">
                  <div className="slx-summary__item">
                    <img src={window.location.origin + `/images/icons/gray/state.svg`} alt="state"/>
                    <div className="slx-summary__item-content">
                      <p className="slx-label">
                        {I18n.t("js.filters.sort.state").toUpperCase()}
                      </p>
                      <p className="slx-value">
                        <b style={{ color: submissionListColorState(original_submission_list.front_office_state) }}>
                          { titleize(parseSubmissionListState(original_submission_list.front_office_state)) }
                        </b>
                        {
                          original_submission_list.state === 'closed' ?
                            ` ${I18n.t("js.common.onDate")} ${original_submission_list.closed_at}`
                          :
                            original_submission_list.state === 'canceled' ?
                              ` ${I18n.t("js.common.onDate")} ${original_submission_list.canceled_at}`
                            :
                              original_submission_list.state === 'received' &&
                                ` ${I18n.t("js.common.onDate")} ${original_submission_list.received_at}`
                        }
                      </p>
                    </div>
                  </div>
                </div>

                <div className="slx-summary__cell">
                  <ItemsCountSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="slx-summary__cell">
                  <InsuranceServiceSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="slx-summary__cell">
                  <DiscountSummary
                    submissionList={original_submission_list}
                  />
                </div>

                <div className="slx-summary__cell">
                  <ShippingServiceSummary
                    submissionList={original_submission_list}
                  />
                </div>

                {
                  isPresent(original_submission_list.middleman) && isMiddleman &&
                    <div className="slx-summary__cell slx-summary__cell--wide">
                      <div className="slx-summary__item">
                        <img src={window.location.origin + `/images/icons/gray/file-signature.svg`} alt="note" width="16px"/>
                        <div className="slx-summary__item-content w-100">
                          <p className="slx-label">
                            {I18n.t('js.editSubmissionListPage.middlemanNote.title').toUpperCase()}
                          </p>
                          {
                            editMiddlemanNote ?
                              <textarea
                                id="middleman_note"
                                rows="1" cols="1000"
                                className={`form-control sale-item-form-input font-size-16px-imp border-left-radius-3px-imp w-100 my-1 py-1`}
                                value={middlemanNote ? middlemanNote : ''}
                                placeholder={I18n.t('js.editSubmissionListPage.middlemanNote.placeholder')}
                                autoFocus={true}
                                onChange={(e) => { setMiddlemanNote(e.target.value) }}
                              />
                              :
                              <p className="slx-value">
                                <span>{ middlemanNote ? middlemanNote : I18n.t('js.editSubmissionListPage.middlemanNote.notSet')}</span>
                                <i className="fas fa-fw fa-edit ml-2 cursor-pointer default_small_label"
                                   onClick={() => setEditMiddlemanNote(true) }
                                ></i>
                              </p>
                          }
                        </div>
                      </div>
                    </div>
                }

                <div className="slx-summary__cell slx-summary__cell--address">
                    {
                      homePickUpRequestedDetails ?
                      <div className="slx-summary__item">
                        <img src={window.location.origin + `/images/icons/gray/home_pick_up.svg`} alt="home_pick_up"/>
                        <div className="slx-summary__item-content">
                          <p className="slx-label">
                            {I18n.t("js.editSubmissionListPage.webComponent.confirmation.text5Compact").toUpperCase()}
                              </p>
                              <div>
                                {
                                  homePickUpAddress ?
                                    <React.Fragment>
                                      <Address
                                        address={homePickUpAddress}
                                        note={original_submission_list.home_pick_up_note}
                                        renderResidence={false}
                                        hidePhoneNumber={true}
                                        displayFullNotes={true}
                                      />

                                      <SubmissionListAddressFormContainerModal
                                        editable={canEditSubmissionList && SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES.includes(original_submission_list.state) && !isDefined(original_submission_list.home_pick_up_request_submitted_to_courier_at)}
                                        submissionList={original_submission_list}
                                        addressType={'home_pick_up_address'}
                                        address={homePickUpAddress}
                                        setAddress={setHomePickUpAddress}
                                        userAddresses={availableUserAddresses(homePickUpAddress)}
                                        setUserAddresses={setUserAddresses}
                                        countries={{[homePickUpAddress.country_id]: countries[homePickUpAddress.country_id]}}
                                        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
                                        setShowErrorModal={setShowErrorModal}
                                      />

                                      {
                                        original_submission_list.home_pick_up_favorite_day_italian_format &&
                                        <p className="mt-4">
                                          <span>{I18n.t("js.editSubmissionListPage.homePickUpProgrammed")} {original_submission_list.home_pick_up_favorite_day_italian_format}</span>
                                          {
                                            original_submission_list.home_pick_up_favorite_hour && original_submission_list.home_pick_up_favorite_hour !== 'all_day' &&
                                            <span>{I18n.t("js.editSubmissionListPage.homePickUpProgrammed1")} {parseHoursRange(original_submission_list.home_pick_up_favorite_hour)}</span>
                                          }
                                        </p>
                                      }
                                    </React.Fragment>
                                  :
                                    <p>
                                      {I18n.t('js.newUserAddressForm.none')}
                                    </p>
                                }

                                {
                                  showHomePickUpInstructions &&
                                  <div className="mt-2">
                                    <PDFGenerator
                                      type={'button'}
                                      generatorText={I18n.t('js.editSubmissionListPage.downloadHomePickUpLabel').toUpperCase()}
                                      cssClassList={"slx-pill slx-pill--ghost border-none"}
                                      pdfUrl={`/submission_lists/${original_submission_list.id}/shipment_instructions.pdf`}
                                      setShowErrorModal={setShowErrorModal}
                                      customImageIcon={window.location.origin + `/images/icons/blue/camion.svg`}
                                      spinnerCssClassList={'maxH-17px max-w-17px'}
                                      downloadMsgCssClassList={'text-uppercase'}
                                    />
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                      :
                        showSelfShipCard ?
                        <div className="slx-summary__item">
                          <img src={window.location.origin + `/images/icons/gray/return_shipment.svg`} alt="order_shipment"/>
                          <div className="slx-summary__item-content">
                            <p className="slx-label">
                              {I18n.t("js.editSubmissionListPage.orderShipmentTitle").toUpperCase()}
                            </p>
                            <PDFGenerator
                              type={'button'}
                              generatorText={I18n.t('js.editSubmissionListPage.shipmentInstructions').toUpperCase()}
                              cssClassList={"slx-pill slx-pill--ghost border-none"}
                              pdfUrl={`/submission_lists/${original_submission_list.id}/shipment_instructions.pdf`}
                              setShowErrorModal={setShowErrorModal}
                              customImageIcon={window.location.origin + `/images/icons/blue/camion.svg`}
                              spinnerCssClassList={'maxH-17px max-w-17px'}
                              downloadMsgCssClassList={'text-uppercase'}
                            />
                          </div>
                        </div>
                      :
                        <div className="slx-summary__item">
                          <img src={window.location.origin + `/images/icons/gray/home_pick_up.svg`} alt="home_pick_up"/>
                          <div className="slx-summary__item-content">
                            <p className="slx-label">
                              {I18n.t("js.editSubmissionListPage.webComponent.confirmation.text5Compact").toUpperCase()}
                            </p>
                            <p className="slx-value slx-value--big">
                              {I18n.t('js.editSubmissionListPage.serviceNotRequested')}
                            </p>
                          </div>
                        </div>
                    }
                    </div>

                    <div className="slx-summary__cell slx-summary__cell--address">
                      <div className="slx-summary__item">
                        <img src={window.location.origin + `/images/icons/gray/return_shipment.svg`} alt="return_shipment" />
                        <div className="slx-summary__item-content">
                          <p className="slx-label">
                            {I18n.t("js.editSubmissionListPage.webComponent.confirmation.text5_1Compact").toUpperCase()}
                          </p>
                          {
                            returnShipmentRequestedDetails ?
                              <div>
                                {
                                  shipmentAddress ?
                                    <React.Fragment>
                                      <Address
                                        address={shipmentAddress}
                                        note={original_submission_list.shipment_note}
                                        renderResidence={false}
                                        hidePhoneNumber={true}
                                        displayFullNotes={true}
                                      />

                                      <SubmissionListAddressFormContainerModal
                                        editable={canEditSubmissionList && SUBMISSION_LIST_PRIOR_TO_RECEIPT_STATES.includes(original_submission_list.state)}
                                        submissionList={original_submission_list}
                                        addressType={'shipment_address'}
                                        address={shipmentAddress}
                                        setAddress={setShipmentAddress}
                                        userAddresses={availableUserAddresses(shipmentAddress)}
                                        setUserAddresses={setUserAddresses}
                                        countries={{[shipmentAddress.country_id]: countries[shipmentAddress.country_id]}}
                                        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
                                        setShowErrorModal={setShowErrorModal}
                                      />
                                    </React.Fragment>
                                  :
                                    <p>
                                      {I18n.t('js.newUserAddressForm.none')}
                                    </p>
                                }
                              </div>
                            :
                              <p className="slx-value slx-value--big">
                                {I18n.t('js.editSubmissionListPage.serviceNotRequested')}
                              </p>
                          }
                        </div>
                      </div>
                    </div>
              </div>

              {
                showDownloadButtons &&
                <div className="d-flex flex-wrap justify-content-center align-items-end text-center mt-4 mb-0 py-0">
                  {
                    original_submission_list.invoice_link &&
                      <a href={original_submission_list.invoice_link} target="_blank"
                         className="slx-pill border-none mx-1 my-2">
                        <img src={window.location.origin + `/images/icons/white/contract.svg`} alt="" height="17px" />
                        {I18n.t('js.editSubmissionListPage.downloadInvoice').toUpperCase()}
                      </a>
                  }
                </div>
              }
              {/*  RIEPILOGO DELLA RICHIESTA DI RECESSO, SOPRA AL TRACKING COME NEL FIGMA */}
              {
                original_submission_list.cancellation_request && ['cancellation_requested', 'canceled'].includes(original_submission_list.state) &&
                  <SubmissionListCancellationNotice
                    cancellationRequest={original_submission_list.cancellation_request}
                  />
              }
              {
                original_submission_list.tracking &&
                  <div id="submission_list_tracking_container" className="row">
                    <SubmissionListTracking submissionList={original_submission_list} />
                  </div>
              }
            </div>




            <div id="submission_list_content_container" className="slx-page">
              {/*  SEZIONE ARTICOLI PRESENTI IN SUBMISSION */}
              <SubmissionListContent
                submissionList={original_submission_list}
                handleShowLargeImage={handleShowLargeImage}
                isMiddleman={isMiddleman}
              />




              <div className="row">
                {/*  SEZIONE RISERVATA ALLA VALUTAZIONE DELL'ORDINE DA PARTE DEL CLIENTE */}
                {
                  feedbacks && feedbacks.length > 0 &&
                  <div className="col-12 slx-section">
                      <div className="row bg-aig-gradient w-100 mx-0 align-items-center py-3 px-3 br-top-8px color-white font-size-18px text-weight-600">
                        { (!isMiddleman || original_submission_list.can_be_evaluated_by_current_user) ? I18n.t('js.feedbacks.title') : I18n.t('js.feedbacks.titleForMiddleman') }
                      </div>

                      <div className="row w-100 mx-0 border-right-solid">
                        {
                          feedbacks.map((feedback, i) => {
                            return <div id={feedback.id} key={feedback.id}
                              className={`${i < feedbacks.length - 1 ? 'col-6 col-md-3' : 'col-' + (12 - ((feedbacks.length - 1) % 2) * 6) + ' col-md-' + (12 - ((feedbacks.length - 1) % 4) * 3)} w-100 p-2 border-left-solid border-bottom-solid d-flex flex-directions-column justify-content-between`}>
                              <span className="color-gray font-size-14px">
                                { parseFeedbackName(feedback.name).toUpperCase() }
                              </span>
                              <div className="mt-2">
                                {
                                  SUBMISSION_LISTS_EVALUATIONS.map((value) => {
                                    const evaluationByFeedback = getEvaluationByFeedback(feedback, evaluations)
                                    return (
                                      <i className={`fas fa-star ${value !== 5 ? 'mr-3 mr-xl-2 mr-xxl-3' : ''} ${cabBeEvaluated() ? 'cursor-pointer' : ''} ${isPresent(evaluationByFeedback) && evaluationByFeedback >= value ? "color-yellow" : "icon-light-gray4"}`}
                                         id={`${feedback.id}_evaluation_${value}_for_submission_list_${original_submission_list.id}`}
                                         key={`${feedback.id}_evaluation_${value}_for_submission_list_${original_submission_list.id}`}
                                         onClick={() => updateEvaluation(feedback.id, value)}
                                      />)
                                  })
                                }
                              </div>
                            </div>
                          })
                        }
                      </div>

                      <div className="row w-100 mx-0 border-right-solid border-left-solid border-bottom-solid br-bottom-8px">
                        <div className="col-12 w-100 p-2" id="review" key="review">
                          <span className="color-gray font-size-14px">
                            {I18n.t('js.editSubmissionListPage.yourObservations').toUpperCase()}
                          </span>
                          <div className="mt-2">
                            <textarea
                              name="review" id="review"
                              rows="3" cols="20"
                              className="form-control review-textarea overflow-hidden pt-1"
                              placeholder={(isMiddleman && !original_submission_list.can_be_evaluated_by_current_user) ? I18n.t('js.editSubmissionListPage.yourObservationsPlaceholderForMiddleman') : (isInAClosingState(original_submission_list) ? (I18n.t(`js.editSubmissionListPage.yourObservationsPlaceholder${!original_submission_list.evaluation_time_limit_expired ? '1' : '3'}`)) : I18n.t('js.editSubmissionListPage.yourObservationsPlaceholder2'))}
                              disabled={!cabBeEvaluated()}
                              value={review ? review : ''}
                              onChange={(e) => setReview(isPresent(e.target.value) ? e.target.value : '')}
                            />
                          </div>
                        </div>
                      </div>
                  </div>
                }



                {/*  SEZIONE RISERVATA AL RIEPILOGO DEL PRICING DELL'ORDINE */}
                <SubmissionListAmounts
                  submissionList={original_submission_list}
                  sectionId={'pricing_summary_section'}
                  sectionTitle={I18n.t('js.editSubmissionListPage.myAmountsTitle')}
                  prefix={amountPrefix}
                  pdfText={I18n.t('js.editSubmissionListPage.downloadSummary')}
                  pdfPricingFor={isMiddlemanOrder ? 'middleman' : 'customer'}
                  setShowErrorModal={setShowErrorModal}
                />

                {/*  SEZIONE CON GLI IMPORTI CHE L'AGGREGATORE APPLICA AL SUO CLIENTE FINALE */}
                {
                  isMiddlemanOrder &&
                  <SubmissionListAmounts
                    submissionList={original_submission_list}
                    sectionId={'customer_pricing_summary_section'}
                    sectionTitle={I18n.t('js.editSubmissionListPage.customerAmountsTitle')}
                    prefix={'customer_'}
                    pdfText={I18n.t('js.editSubmissionListPage.downloadCustomerSummary')}
                    pdfPricingFor={'customer'}
                    setShowErrorModal={setShowErrorModal}
                  />
                }
              </div>

              {/*  SEZIONE RESI E RIMBORSI (DIRITTO DI RECESSO)
                   L'ordine passato da un point non da' diritto di recesso dal sito: la sezione
                   resta nascosta sia al point sia al suo cliente, invece di mostrarla e negarla dopo */}
              {
                !isMiddleman && !isPresent(original_submission_list.middleman_id) &&
                <SubmissionListWithdrawalCard submissionList={original_submission_list} />
              }
            </div>

            <ShowLargeImageModal
              blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
              showZoomImg={showZoomImg}
              setShowZoomImg={setShowZoomImg}
            />

            <ErrorModal
              showErrorModal={showErrorModal}
              setShowErrorModal={setShowErrorModal}
            />

            <SuccessFlashMessage
              showSuccessFlashMessage={showSuccessFlashMessage}
              setShowSuccessFlashMessage={setShowSuccessFlashMessage}
            />
          </React.Fragment>
      }
    </React.Fragment>
  );
};

export default ShowPageSubmissionList;
